var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useIntl } from "react-intl";
import { EntityRow } from "./EntityRow";
import css from "./EntityRow.module.css";
/** {@link EntityRow} wrapped as a dnd-kit sortable item with a drag handle. */
export var SortableEntityRow = function (_a) {
    var id = _a.id, rowProps = __rest(_a, ["id"]);
    var formatMessage = useIntl().formatMessage;
    var _b = useSortable({ id: id }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform, transition = _b.transition, isDragging = _b.isDragging;
    var style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
    };
    var dragHandle = (React.createElement("span", __assign({ className: css.handle, "aria-label": formatMessage({
            id: "ui-br-agency.title.contributions.reorder",
        }) }, attributes, listeners), "\u283F"));
    return (React.createElement(EntityRow, __assign({ ref: setNodeRef, style: style, className: isDragging ? css.dragging : undefined, dragHandle: dragHandle }, rowProps)));
};
SortableEntityRow.displayName = "SortableEntityRow";
